import { render, staticRenderFns } from "./RegisterFourthStep.vue?vue&type=template&id=554eb5c6&scoped=true&"
import script from "./RegisterFourthStep.vue?vue&type=script&lang=js&"
export * from "./RegisterFourthStep.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFourthStep.vue?vue&type=style&index=0&id=554eb5c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554eb5c6",
  null
  
)

export default component.exports